export type BenchmarkMode = "avg" | "tq" | "top10" | "best";

export const BENCHMARK_LABELS: Record<BenchmarkMode, string> = {
  avg: "Average",
  tq: "Top 25%",
  top10: "Top 10%",
  best: "Best in Class",
};

export const BENCHMARK_SUBTITLES: Record<BenchmarkMode, string> = {
  avg: "vs. industry peers avg",
  tq: "vs. top quartile peers",
  top10: "vs. top 10% peers",
  best: "vs. best in class peer",
};
